var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title-taxes")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("app-label", {
                            attrs: {
                              label: _vm.$ct("labels.recupel").toString(),
                              value: _vm.product.RecupelTax,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("app-label", {
                            attrs: {
                              label: _vm.$ct("labels.leeggoed").toString(),
                              value: _vm.product.LeeggoedTax,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("app-label", {
                            attrs: {
                              label: _vm.$ct("labels.auvibel").toString(),
                              value: _vm.product.AuvibelTax,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("app-label", {
                            attrs: {
                              label: _vm.$ct("labels.accijnzen").toString(),
                              value: _vm.product.AccijnzenTax,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("app-label", {
                            attrs: {
                              label: _vm.$ct("labels.bebat").toString(),
                              value: _vm.product.BebatTax,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("app-label", {
                            attrs: {
                              label: _vm.$ct("labels.ecoboni").toString(),
                              value: _vm.product.EcoboniTax,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("app-label", {
                            attrs: {
                              label: _vm.$ct("labels.reprobel").toString(),
                              value: _vm.product.ReprobelTax,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("app-label", {
                            attrs: {
                              label: _vm.$ct("labels.fostplus").toString(),
                              value: _vm.product.FostplusTax,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.product.Images.length > 0
        ? _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-card",
                [
                  _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("images")))]),
                  _c(
                    "w-card-content",
                    [_c("app-images", { attrs: { product: _vm.product } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "4", grow: "" } },
        [
          _c("app-product-info-accounting", {
            style: { flexGrow: 1 },
            attrs: { product: _vm.product },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "8", grow: "" } },
        [
          _c(
            "w-card",
            { style: { flexGrow: 1 } },
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title-fields")))]),
              _c(
                "w-card-content",
                [
                  _vm.isAllowed(27)
                    ? _c("app-extra-fields-info", {
                        attrs: {
                          value: _vm.product.ExtraFields,
                          "name-settings": _vm.extraFieldNameSettings,
                          "tab-id": "",
                        },
                      })
                    : _c(
                        "w-row",
                        [
                          _c("app-missing-module", {
                            attrs: { "module-id": 27 },
                          }),
                        ],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("app-product-info-aws-documents", {
            attrs: { product: _vm.product },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }